module.exports = __webpack_public_path__ + "img/nxp.149ca791.jpg";